<p>favorites-page-block works!</p>
